import { render, staticRenderFns } from "./SkillMatch.vue?vue&type=template&id=5f3fb026&scoped=true"
import script from "./SkillMatch.vue?vue&type=script&lang=ts"
export * from "./SkillMatch.vue?vue&type=script&lang=ts"
import style0 from "./SkillMatch.vue?vue&type=style&index=0&id=5f3fb026&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3fb026",
  null
  
)

export default component.exports